import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { SelectChangeEvent } from "@mui/material";
import { ChangeEvent } from 'react'; 
import { InputPropsTypes } from "./types/inputTypes";

interface SelectFieldProps {
  label: string;
  name: string;
  options: { label: string; value: string }[];
  isRequired?: boolean;
  inputProps: InputPropsTypes;
}

const SelectFieldInput = ({ label, name, options, inputProps, isRequired=false}: SelectFieldProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    inputProps.onChange(event)
  };

  return (
    <Box>
      <Typography mb={0.5} color="text.primary">{label}{isRequired && "*"}</Typography>
      <TextField 
        fullWidth 
        select 
        name={name} 
        value={inputProps.value}
        error={inputProps.error}
        helperText={inputProps.helperText}
        onChange={handleChange}
        sx={{bgcolor: "#ffffff"}}>
          {options.map((item) => {
            return (
              <MenuItem key={item.value} selected value={item.value}>
                {item.label}
              </MenuItem>
            )
          })}
      </TextField>
    </Box>
  );
};

export default SelectFieldInput;
